import { MutableRefObject, useEffect, useRef } from 'react'
import { useWindowSize } from 'react-use'

import { HEADER_ID } from 'components/header'

interface ScrollToOptions {
  /**
   * @default 25px
   */
  topOffset?: number
  behavior?: ScrollBehavior
}

const offset = (el: HTMLElement) => {
  const rect = el.getBoundingClientRect()
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  return { top: rect.top + scrollTop }
}

export const useScrollTo = () => {
  const headerHeight = useRef<null | number>(null)
  const headerElement = useRef<null | HTMLElement>(null)
  const { width } = useWindowSize()

  useEffect(() => {
    headerElement.current = document.getElementById(HEADER_ID)
  }, [])

  useEffect(() => {
    if (headerElement.current) {
      headerHeight.current = headerElement.current?.clientHeight
    }
  }, [width])

  const scrollTo = (element: MutableRefObject<HTMLElement | null>, options?: ScrollToOptions) => {
    if (element.current && headerHeight.current) {
      const topPosition = offset(element.current)

      window.scrollTo({
        top: topPosition.top - headerHeight.current - (options?.topOffset ?? 25),
        behavior: options?.behavior ?? 'smooth',
      })
    }
  }

  return scrollTo
}
